import { Component, Inject, inject, signal, TemplateRef, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { CommonModule } from '@angular/common';
import { ChangeLanguageComponent } from '../../pages/setting/change-language/change-language.component';
import { ChangeThemesComponent } from '../change-themes/change-themes.component';

@Component({
  selector: 'app-header-auth',
  standalone: true,
  imports: [
    CommonModule,
    ChangeLanguageComponent,
    ChangeThemesComponent

  ],
  templateUrl: './header-auth.component.html',
  styleUrl: './header-auth.component.css'
})
export class HeaderAuthComponent {

  isSystemDark = false
  selectedLanguage: any;
  
  private modalService = inject(NgbModal);
  closeResult: WritableSignal<string> = signal('');
    
  constructor(
    public admin: AdminService,
    private translate: TranslateService,
    private languageService: LanguagesService,
    public ThemeService: ThemeService
    ) {
      this.languageService.selectedLanguage$.subscribe(
        (lang: any) => {this.selectedLanguage = lang}
      );

        // სისტემური თემა
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      this.isSystemDark = prefersDark.matches;

      // ამ ცვლილებების შესაფერისი განსაზღვრა
      prefersDark.addEventListener('change', (event) => {
        this.isSystemDark = event.matches;
      });
  }


  open(content: TemplateRef<any>) {
    this.modalService.open(content, { 
      backdropClass: 'light-blue-backdrop',
      scrollable: true,
      size: 'sm',
      }).result.then(
      (result) => {
        this.closeResult.set(`Closed with: ${result}`);
      },
      (reason) => {
        this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
      },
    );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }
  


}
